export default "__VITE_ASSET__SaJmXY2r__"